// Pages
import Landingpage from "./Pages/Guest/Landingpage";
import Login from "./Pages/Guest/Login";
import Signup from "./Pages/Guest/Signup";
import Dashboard from "./Pages/Member/Dashboard";

// Other
import { React, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";

// Custom Hooks
import useSessionManager from "./Hooks/Authentication/useSessionManager";

const App = () => {
  const sessionManager = useSessionManager();
  const [token, setToken] = useState(false);
  const isAuth = sessionManager.isAuth();

  if (token) {
    sessionStorage.setItem("token", JSON.stringify(token));
  }

  useEffect(() => {
    setToken(sessionManager.get);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="App w-screen h-screen flex items-center flex-col bg-dark-700 text-text-dark-700 ">
      <Routes>
        {/* Guest */}
        <Route
          exact
          path="/"
          element={isAuth ? <Navigate to="/dashboard" /> : <Landingpage />}
        />

        {/* Redirect */}
        <Route
          exact
          path="/redirect"
          element={isAuth ? <Navigate to="/dashboard" /> : <Navigate to="/" />}
        />

        <Route
          path="/login"
          element={isAuth ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path="/signup"
          element={isAuth ? <Navigate to="/dashboard" /> : <Signup />}
        />

        {/* Member */}
        <Route
          path="/dashboard"
          element={isAuth ? <Dashboard /> : <Navigate to="/login" />}
        />

        <Route
          path="/dashboard/:page?"
          element={isAuth ? <Dashboard /> : <Navigate to="/login" />}
        />
      </Routes>
    </main>
  );
};

export default App;
